import { getHttpClient } from "@/http-client";

const baseUrl = "/api";

export async function getCsrfToken() {
  const { data } = await getHttpClient().get(`${baseUrl}/csrf_token`);
  return data.csrf_token;
}
